/**
 * What the project menu's material-mapping entry is called, in both views of the projects overview.
 *
 * Renamed for a Viewer rather than hidden, because the mapping page genuinely IS readable with
 * Viewer access: realtimelca-api's `MappingController` asserts `Permission.ViewProject` on its read
 * endpoints and `EditProject` only on the writes. Nothing was broken about the destination — only
 * the promise in the label, which offered a Viewer an action they cannot perform (RTLCA-5583).
 *
 * Shared by the grid card and the table row so the two renderings of the same project cannot drift.
 * They already had: the card said "Map Materials" and the row "Go to mapping" for the same
 * destination, and a lock applied to only one of them is one view-toggle click away from being
 * bypassed.
 */
export const materialMappingMenuLabel = (canEdit: boolean): string => (canEdit ? "Map Materials" : "View Materials");

export default materialMappingMenuLabel;
